import React from "react";
import styled from "styled-components";

import { Spinner } from "@origin-digital/style-guide";

const LoadingBase = styled.div`
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  top: 0;
  right: 0;
  pointer-events: none;
  position: fixed;
  z-index: 10;
  transition: opacity 250ms ease-in-out;

  svg {
    transform: scale(1);
    transition: scale 800ms ease-in-out;
  }
`;

export const Loading: React.FC = () => (
  <LoadingBase>
    <Spinner size="lg" />
  </LoadingBase>
);
